/**
 * Order-related helpers for Backside Engraving: line items and default text/font from order.
 */

/**
 * Line items shown in the Backside Engraving modal: any order line item whose id is in the allowed set.
 */
export function getBacksideEngravingLineItems(order, allowedIds) {
  const items = order?.lineItems || []
  if (!allowedIds || !Array.isArray(allowedIds) || allowedIds.length === 0) return []
  const idSet = new Set(allowedIds.map((id) => String(id)))
  return items.filter((li) => {
    const id = li?.id
    if (id == null) return false
    return idSet.has(String(id))
  })
}

/**
 * Get backside engraving default values from line item properties.
 * Props can look like "Engraving - Upsell 1 - Text 1: KIAN". Match by suffix: "Text 1", "Text 2", "Text 3", "Text 4", "Font".
 */
export function getBacksideEngravingFromLineItem(lineItem) {
  const props = lineItem?.properties || []
  const result = { text1: '', text2: '', text3: '', text4: '', font: '' }
  const suffixes = ['Text 1', 'Text 2', 'Text 3', 'Text 4', 'Font']
  for (const { name, value } of props) {
    if (name == null || value == null) continue
    const nameStr = String(name).trim()
    const valueStr = String(value).trim()
    for (const suffix of suffixes) {
      const re = new RegExp('\\s*-\\s*' + suffix.replace(/\s/g, '\\s') + '\\s*$', 'i')
      if (re.test(nameStr)) {
        if (suffix === 'Text 1') result.text1 = valueStr
        else if (suffix === 'Text 2') result.text2 = valueStr
        else if (suffix === 'Text 3') result.text3 = valueStr
        else if (suffix === 'Text 4') result.text4 = valueStr
        else if (suffix === 'Font') result.font = valueStr
        break
      }
    }
  }
  return result
}

/**
 * Map prop font name (e.g. Roboto, Roboto Slab) to dropdown value (modern, classic, italic).
 */
export function fontValueFromProp(fontName) {
  if (!fontName || typeof fontName !== 'string') return 'modern'
  const s = fontName.trim().toLowerCase()
  if (s.includes('slab')) return 'classic'
  if (s.includes('dancing') || s.includes('script')) return 'italic'
  return 'modern'
}
